'use strict';

import {addCustomEventListener} from './helpers';

export const scrollToTop = (() => {

  const eventListeners = () => {
    addCustomEventListener('[data-scroll="to-top"]', 'click', function (e) {
      window.shApp.scrollTo(-window.shApp.scrollTop, false, true);
    });
  };

  const init = () => {
    const buttonToTop = document.querySelector('[data-scroll="to-top"]');
    if (buttonToTop) {
      eventListeners();
    }
  };

  return {
    init
  };
})();
